import { render } from "./SiteNavigation.vue?vue&type=template&id=4f015b9f&scoped=true"
import script from "./SiteNavigation.vue?vue&type=script&lang=js"
export * from "./SiteNavigation.vue?vue&type=script&lang=js"

import "./SiteNavigation.vue?vue&type=style&index=0&id=4f015b9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f015b9f"]])

export default __exports__